import axios from 'axios';
import UiElement from '../../../shared/ui-element/ui-element';

import analytics, { events } from '../../../shared/analytics';

class EmailSubscription extends UiElement {
  ui = {
    emailInput: '.js-email-subscription-email-input',
    emailBtn: '.js-email-subscription-submit-btn',
  };

  events = {
    'submit @rootElement': 'handleFormSubmit',
  };

  static formGroupControlValidClass = 'form-group__form-control_valid';

  static formGroupControlInvalidClass = 'form-group__form-control_invalid';

  constructor(options) {
    super(options);

    this.onSubscribeSuccess = options.onSubscribeSuccess || (() => {});
  }

  onInit() {
    this.apiUrl = this.rootElement.action;
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const btn = this.ui.emailBtn;

    btn.disabled = true;

    const email = this.ui.emailInput.value;

    return axios.post(this.apiUrl, { email })
      .then(() => {
        this.emailSubscriptionSuccess();
        this.onSubscribeSuccess();
      })
      .catch(this.emailSubscriptionError)
      .then(() => {
        btn.disabled = false;
      });
  }

  setValidFormControl(formControl) {
    formControl.classList.remove(EmailSubscription.formGroupControlInvalidClass);
    formControl.classList.add(EmailSubscription.formGroupControlValidClass);
  }

  setInvalidFormControl(formControl) {
    formControl.classList.remove(EmailSubscription.formGroupControlValidClass);
    formControl.classList.add(EmailSubscription.formGroupControlInvalidClass);
  }

  emailSubscriptionSuccess = () => {
    this.setValidFormControl(this.ui.emailInput);

    this.sendAnalyticsEvent();
  };

  emailSubscriptionError = () => {
    this.setInvalidFormControl(this.ui.emailInput);
  };

  sendAnalyticsEvent = () => {
    analytics.trackEvent({
      ...events.EMAIL_SUBSCRIPTION,
      eventLabel: 'Footer',
    });
  };
}

export default EmailSubscription;
